import React, {Fragment, useState, useRef, useEffect} from "react";
import {
  TextField,
  AppBar,
  Typography,
  Button,
  Toolbar,
  Collapse,
  Switch,
  CircularProgress,
} from "@material-ui/core";
import axios from "axios";
import {Close, Save} from "@material-ui/icons";
import {makeStyles} from "@material-ui/core/styles";
import {Alert, Autocomplete} from "@material-ui/lab";
import {getCookie} from "components/auth/Helpers";
import NestedTable from "./NestedTable.js";
import {useForm} from "react-hook-form";
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  formControl: {
    minWidth: "100%",
  },
}));
const GeneralPrices = (props) => {
  const token = getCookie("token");
  const {register, handleSubmit, watch} = useForm();
  const [openAlertSuccess, setOpenAlertSuccess] = useState(false);
  const [openAlertError, setOpenAlertError] = useState(false);
  const [serviceTypeValue, setServiceTypeValue] = useState({});

  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [countries, setCountries] = useState([]);
  const [citiesIn, setCitiesIn] = useState([]);
  const [neighbourhoodsIn, setNeighbourhoodsIn] = useState([]);
  const [tiersIn, setTiersIn] = useState([]);
  const [citiesOut, setCitiesOut] = useState([]);
  const [neighbourhoodsOut, setNeighbourhoodsOut] = useState([]);
  const [tiersOut, setTiersOut] = useState([]);
  const [operations, setOperations] = useState([]);
  const [fridgeTypes, setFridgeTypes] = useState([]);
  const classes = useStyles(); //custom css

  const [formValues, setFormValues] = useState({
    daily_cbm_storage_price: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios(`${process.env.REACT_APP_BASE_URL}/generalPrices`, {
        responseType: "json",
        headers: {Authorization: `Bearer ${token}`},
      })
        .then((response) => {
          if (response.data)
            setFormValues({...response.data, daily_cbm_storage_price: response.data.daily_cbm_storage_price});
          return response.data;
        })
        .then((response) => {})
        .finally(() => {
          setIsLoading(false);
        });
    };
    fetchData();
  }, []);

  const handleOnSubmitForm = async (data, e) => {
    if (formValues._id) {
      await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_BASE_URL}/generalPrices/${formValues._id}`,
        headers: {Authorization: `Bearer ${token}`},
        data: {...data, _id: formValues._id},
      })
        .then(function (response) {
          toast.success("Successfully Updated", {onClose: () => props.handleClose()});
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      delete formValues._id;
      await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_URL}/generalPrices`,
        headers: {Authorization: `Bearer ${token}`},
        data: data,
      })
        .then(function (response) {
          setOpenAlertSuccess(true);

          toast.success("Successfully Added", {onClose: () => props.handleClose()});
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  return (
    <Fragment>
      <ToastContainer />
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Close onClick={props.handleClose} className="btnIcon" />
          <Typography variant="h6" className={classes.title}>
            {"General Prices"}
          </Typography>
        </Toolbar>
      </AppBar>
      <Collapse in={openAlertSuccess}>
        <Alert severity="success" onClick={() => setOpenAlertSuccess(false)}>
          General Prices is successfully created
        </Alert>
      </Collapse>
      <Collapse in={openAlertError}>
        <Alert severity="error" onClick={() => setOpenAlertError(false)}>
          Please validate the Form and submit it again
        </Alert>
      </Collapse>
      {!isLoading ? (
        <div style={{padding: "10px 30px"}}>
          <form onSubmit={handleSubmit(handleOnSubmitForm)}>
            <div className="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label htmlFor="name">Daily Storage Price per CMB</label>
                  <input
                    type="text"
                    className="form-control"
                    name="daily_cbm_storage_price"
                    id="daily_cbm_storage_price"
                    placeholder="Daily Storage Price per CMB"
                    ref={register}
                    defaultValue={formValues.daily_cbm_storage_price}
                  />
                </div>
              </div>

              <div className="col-12 d-flex flex-row-reverse">
                <button className="btn btn-lg btn-primary d-flex" type="submit">
                  <Save /> Save
                </button>
                &nbsp;&nbsp;
                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  className="btn btn--save"
                  onClick={props.handleClose}
                  startIcon={<Close />}
                >
                  Close
                </Button>
              </div>
            </div>
          </form>
        </div>
      ) : (
        <CircularProgress size={30} className="pageLoader" />
      )}
    </Fragment>
  );
};

export default GeneralPrices;
